import { render, staticRenderFns } from "./SponsorsListModal.vue?vue&type=template&id=080dd1bf&scoped=true&"
import script from "./SponsorsListModal.vue?vue&type=script&lang=js&"
export * from "./SponsorsListModal.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsListModal.vue?vue&type=style&index=0&id=080dd1bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080dd1bf",
  null
  
)

export default component.exports